module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"noVacancyLists":"Вы ещё не создали подборку вакансий","badLists":"У вас есть подборки, в которых все вакансии перешли в архив"}}')
  delete Component.options._Ctor
}
